import { AnyAction } from "redux";
import {
    FETCH_DISCIPLINE_OFFERS, RECEIVE_DISCIPLINE_OFFERS,
    SAVE_DISCIPLINE_OFFER, SAVE_DISCIPLINE_OFFER_SUCCESS,
    DELETE_DISCIPLINE_OFFER, DELETE_DISCIPLINE_OFFER_SUCCESS,
    FETCH_DOF_STUDENTS, RECEIVE_DOF_STUDENTS
} from "../actionTypes";

interface DisciplineOfferState {
    isFetching: boolean;
    isSaving: boolean;
    isFetchingStudents: boolean;
    disciplineOffers: any[];
    dofStudents: any[];
}

const initialState: DisciplineOfferState = {
    isFetching: false,
    isSaving: false,
    isFetchingStudents: false,
    disciplineOffers: [],
    dofStudents: [],
}

const disciplineOfferReducer = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case FETCH_DISCIPLINE_OFFERS: return { ...state, isFetching: true };
        case RECEIVE_DISCIPLINE_OFFERS: return { ...state, isFetching: false, disciplineOffers: action.payload };
        case SAVE_DISCIPLINE_OFFER: return { ...state, isSaving: true };
        case SAVE_DISCIPLINE_OFFER_SUCCESS: return { ...state, isSaving: false };
        case DELETE_DISCIPLINE_OFFER: return { ...state, isSaving: true };
        case DELETE_DISCIPLINE_OFFER_SUCCESS: return { ...state, isSaving: false };
        case FETCH_DOF_STUDENTS: return { ...state, isFetchingStudents: true };
        case RECEIVE_DOF_STUDENTS: return { ...state, isFetchingStudents: false, dofStudents: action.payload };
        default: return state;
    }
}
export default disciplineOfferReducer;
